import { useState } from "react";
import { Smartphone, X, Share, PlusSquare } from "lucide-react";

const isStandalone = () =>
  window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true;
const isIOS = () => /iphone|ipad|ipod/i.test(navigator.userAgent);

// "Add to Home Screen" helper: native prompt on Android/Chrome, illustrated steps on iPhone
export const InstallAppButton = ({ dark = false }) => {
  const [showGuide, setShowGuide] = useState(false);
  if (isStandalone()) return null;

  const install = async () => {
    const p = window.__installPrompt;
    if (p) {
      p.prompt();
      try { await p.userChoice; } catch {}
      window.__installPrompt = null;
      return;
    }
    setShowGuide(true);
  };

  return (
    <>
      <button type="button" onClick={install} data-testid="install-app-btn"
        className={`w-full mt-3 flex items-center justify-center gap-2 rounded-sm py-2.5 text-xs font-bold uppercase tracking-wider border ${dark ? "border-[#333] text-[#9CA3AF] hover:text-white hover:border-[#E32C17]" : "border-gray-300 text-gray-600 hover:text-[#E32C17] hover:border-[#E32C17]"}`}>
        <Smartphone size={14} /> Add to Home Screen
      </button>
      {showGuide && (
        <div className="fixed inset-0 z-50 bg-black/70 flex items-center justify-center p-4" onClick={() => setShowGuide(false)} data-testid="install-guide">
          <div className="bg-white rounded-sm p-5 max-w-sm w-full space-y-3" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-center justify-between">
              <div className="text-sm font-bold text-[#0F172A]">Add Stancor to your Home Screen</div>
              <button onClick={() => setShowGuide(false)} data-testid="install-guide-close"><X size={16} className="text-gray-400" /></button>
            </div>
            {isIOS() ? (
              <ol className="space-y-2.5 text-sm text-[#334155]">
                <li className="flex items-start gap-2"><span className="w-5 h-5 shrink-0 bg-[#E32C17] text-white rounded-full text-[11px] font-bold flex items-center justify-center">1</span>
                  <span>Open this page in <b>Safari</b>, tap the <Share size={13} className="inline mx-0.5 text-sky-600" /> <b>Share</b> button (bottom bar)</span></li>
                <li className="flex items-start gap-2"><span className="w-5 h-5 shrink-0 bg-[#E32C17] text-white rounded-full text-[11px] font-bold flex items-center justify-center">2</span>
                  <span>Scroll down and tap <PlusSquare size={13} className="inline mx-0.5 text-gray-600" /> <b>Add to Home Screen</b></span></li>
                <li className="flex items-start gap-2"><span className="w-5 h-5 shrink-0 bg-[#E32C17] text-white rounded-full text-[11px] font-bold flex items-center justify-center">3</span>
                  <span>Tap <b>Add</b> — the Stancor icon appears like a normal app</span></li>
              </ol>
            ) : (
              <ol className="space-y-2.5 text-sm text-[#334155]">
                <li className="flex items-start gap-2"><span className="w-5 h-5 shrink-0 bg-[#E32C17] text-white rounded-full text-[11px] font-bold flex items-center justify-center">1</span>
                  <span>Open this page in <b>Chrome</b>, tap the <b>⋮</b> menu (top right)</span></li>
                <li className="flex items-start gap-2"><span className="w-5 h-5 shrink-0 bg-[#E32C17] text-white rounded-full text-[11px] font-bold flex items-center justify-center">2</span>
                  <span>Tap <b>Add to Home screen</b> (or <b>Install app</b>)</span></li>
                <li className="flex items-start gap-2"><span className="w-5 h-5 shrink-0 bg-[#E32C17] text-white rounded-full text-[11px] font-bold flex items-center justify-center">3</span>
                  <span>Confirm — the Stancor icon appears like a normal app</span></li>
              </ol>
            )}
            <div className="text-[11px] text-gray-500">Opens full-screen with the Stancor icon — one tap, no browser bars, stays signed in for 30 days.</div>
          </div>
        </div>
      )}
    </>
  );
};
